import { render, staticRenderFns } from "./turntableRule.vue?vue&type=template&id=028fda30&scoped=true&"
import script from "./turntableRule.vue?vue&type=script&lang=js&"
export * from "./turntableRule.vue?vue&type=script&lang=js&"
import style0 from "./turntableRule.vue?vue&type=style&index=0&id=028fda30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fda30",
  null
  
)

export default component.exports